import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

// Panelin tek logosu: Berlin Esnaf (BES). Acik/koyu tema ve
// acik/daraltilmis menu icin ayni gorsel kullaniliyor.
import logo from "../../assets/images/logo2.png";

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu">
        {/* Logo olculeri: acik menude 46px, menu daraltilinca 34px.
            Onceki 17-19px degerleri 70px yuksekligindeki bant icinde
            neredeyse gorunmuyordu. */}
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="Berlin Esnaf" height="34" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="Berlin Esnaf" height="46" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="Berlin Esnaf" height="34" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="Berlin Esnaf" height="46" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
